// Shop.
export const autoShip = () => '/auto-ship';
export const shopPods = () => '/shop-pods';

// Account.
export const account = ({ version = '' } = {}) => `${version}/account`;

// Addresses.
export const addresses = ({ version = '', addressType = '' } = {}) =>
  `${version}/account/addresses/${addressType}`;
export const newAddress = ({ version = '', addressType = '' } = {}) =>
  `${version}/account/addresses/${addressType}/new`;
export const editAddress = ({ id, version = '', addressType = '' } = {}) =>
  `${version}/account/addresses/${addressType}/${id}/edit`;

// Membership.
export const cancelMembership = ({ version = '' } = {}) =>
  `${version}/account/membership/cancel`;
export const editMembershipOrderDate = ({ version = '' } = {}) =>
  `${version}/account/membership/order-date/edit`;
export const editMembershipPaymentMethod = ({ version = '' } = {}) =>
  `${version}/account/membership/payment-method/edit`;
export const editMembershipPods = ({ version = '' } = {}) =>
  `${version}/account/membership/pods/edit`;
export const editMembershipShipping = ({ version = '' } = {}) =>
  `${version}/account/membership/shipping/edit`;
export const editMembershipBilling = ({ version = '' } = {}) =>
  `${version}/account/membership/billing/edit`;
export const membership = ({ version = '' } = {}) =>
  `${version}/account/membership`;
export const postponeMembership = ({ version = '' } = {}) =>
  `${version}/account/membership/postpone`;
export const reviewMembershipPods = ({ version = '' } = {}) =>
  `${version}/account/membership/pods/review`;
export const newMembership = ({ version = '' } = {}) =>
  `${version}/account/membership/new`;

// Orders
export const orders = ({ version = '' } = {}) => `${version}/account/orders`;
export const order = ({ number, version = '' } = {}) =>
  `${version}/account/orders/${number}`;
export const cancelOrder = ({ number } = {}) =>
  `/account/orders/${number}/cancel`;

// Profile.
export const profile = ({ version = '' } = {}) => `${version}/account/profile`;
export const editProfile = ({ version = '' } = {}) =>
  `${version}/account/profile/edit`;
export const editProfilePhone = ({ version = '' } = {}) =>
  `${version}/account/phone/edit`;

// Signout.
export const signout = ({ version = '' } = {}) => `${version}/signout`;

// Register.
export const registerProduct = ({ version = '' } = {}) =>
  `${version}/account/register`;

// Vip.
export const vip = () => `/account/vip`;
export const vipPerks = () => `/account/vip/perks`;
export const vipResources = () => `/account/vip/resources`;
export const vipNewMembership = () => `/account/vip/membership/new`;

// Warranty Flow
export const claimWarranty = pid => `/claim-warranty?pid=${pid}`;



// WEBPACK FOOTER //
// ./app/javascript/apps/account/paths.js